export default __webpack_public_path__ + "static/media/clef-transparent.472f658b.png";